import { useEffect, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import ListaEnvioEmailHttp from '../../../../../services/api/https/registration/lista-envio-email.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const ENVIO_EMAIL_ACTIONS = {
  LOADING_LISTA_EMAILS: 'LOADING_LISTA_EMAILS',
  LOADING_ENVIANDO_EMAIL: 'LOADING_ENVIANDO_EMAIL',
  LOADING_EMAILS: 'LOADING_EMAILS',
  NONE: 'NONE',
  EMAIL_ENVIADOS_COM_SUCESSO: 'EMAIL_ENVIADOS_COM_SUCESSO',
}

export default function useEnvioEmailState(ciclo, operationCenterId) {
  const [listasEmail, setListasEmail] = useState([])
  const [listaSelecionada, setListaSelecionada] = useState('')
  const [isLoading, setIsLoading] = useState(ENVIO_EMAIL_ACTIONS.NONE)
  const [error, setError] = useState(null)
  const [emails, setEmails] = useState([])
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [mensagem, setMensagem] = useState(null)

  useEffect(() => {
    ciclo && fetchListaEmails()
  }, [])

  // Events
  async function onBtnEnviarClick() {
    try {
      setIsLoading(ENVIO_EMAIL_ACTIONS.LOADING_ENVIANDO_EMAIL)
      const selectedEmails = emails.filter(e => e.selected)
      if (selectedEmails.length === 0) throw new Error('Nenhum Email selecionado.')
      await CicloEntregaAcoesHttp.enviarEmail(
        ciclo.id,
        selectedEmails.map(email => email.id),
      )
      setMensagem(ENVIO_EMAIL_ACTIONS.EMAIL_ENVIADOS_COM_SUCESSO)
    } catch (error) {
      setError(errorHandler(error))
    } finally {
      setIsLoading(ENVIO_EMAIL_ACTIONS.NONE)
    }
  }

  function onCheckBoxRowClicked(email) {
    setEmails(prevEmails => {
      return prevEmails.map(e => {
        if (e.id === email.id) {
          return { ...e, selected: !e.selected }
        }
        return { ...e }
      })
    })
    setSelecionarTodos(false)
  }

  function onSelecionarTodos() {
    setSelecionarTodos(!selecionarTodos)
    setEmails(prevEmails => {
      return prevEmails.map(e => ({ ...e, selected: !selecionarTodos }))
    })
  }

  async function onListaEmailChange(lista) {
    try {
      setListaSelecionada(lista)
      setIsLoading(ENVIO_EMAIL_ACTIONS.LOADING_EMAILS)
      const _emails = await ListaEnvioEmailHttp.getEmails(lista.id)
      setEmails(prepareEmails(_emails))
    } catch (error) {
      setError(errorHandler(error))
    } finally {
      setIsLoading(ENVIO_EMAIL_ACTIONS.NONE)
    }
  }

  function resetError() {
    setError(null)
  }

  function resetMessage() {
    setMensagem(null)
  }

  //Helpers
  function prepareEmails(incomingEmails) {
    const _emails = incomingEmails.map(e => {
      if (e.tps) {
        return { ...e, tps: e.tps.map(t => t.tp_name).join(', ') }
      }
      return { ...e }
    })
    return _emails
  }
  async function fetchListaEmails() {
    try {
      setIsLoading(ENVIO_EMAIL_ACTIONS.LOADING_LISTA_EMAILS)
      const _listasEmails = await ListaEnvioEmailHttp.getListas(operationCenterId)
      setListasEmail(_listasEmails)
    } catch (error) {
      setError(errorHandler(error))
    } finally {
      setIsLoading(ENVIO_EMAIL_ACTIONS.NONE)
    }
  }

  return {
    listasEmail,
    listaSelecionada,
    isLoading,
    error,
    emails,
    selecionarTodos,
    mensagem,
    onBtnEnviarClick,
    onCheckBoxRowClicked,
    onSelecionarTodos,
    onListaEmailChange,
    resetError,
    resetMessage,
  }
}
